module.exports = {
      id: "icon-center-grid-stats-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-center-grid-stats",
      toString: function () {
        return this.url;
      }
    }